export default __webpack_public_path__ + "static/media/withdrawal-inactive.6a7fb199.svg";